export default __webpack_public_path__ + "static/media/home-header.78ea621b.jpg";